import { graphql } from "@/graphql/generated";

// ============== QUERIES ======================
export const getActiveViewQueryDocument = graphql(/* GraphQL */ `
  query GetActiveView($input: GetActiveViewInput!) {
    activeView(getActiveViewInput: $input) {
      id
      userId
      workspaceId
      key
      showColumnHeaders
      sectionColumnId
      subSectionColumnId
      globalFilter
      columnFilters {
        id
        value
      }
      columnOrder
      columnVisibility
      sorting {
        id
        desc
      }
      expanded
      createdAt
      updatedAt
      storedViewId
      storedView {
        id
        workspaceId
        key
        name
        ownerId
        ownerType
        default
        showColumnHeaders
        sectionColumnId
        subSectionColumnId
        globalFilter
        columnFilters {
          id
          value
        }
        columnOrder
        columnVisibility
        sorting {
          id
          desc
        }
        expanded
        createdAt
        updatedAt
      }
    }
  }
`);

export const getActiveViewListQueryDocument = graphql(/* GraphQL */ `
  query GetActiveViewList($input: GetActiveViewListInput!) {
    activeViewList(getActiveViewListInput: $input) {
      id
      userId
      workspaceId
      key
      showColumnHeaders
      sectionColumnId
      subSectionColumnId
      globalFilter
      columnFilters {
        id
        value
      }
      columnOrder
      columnVisibility
      sorting {
        id
        desc
      }
      expanded
      createdAt
      updatedAt
      storedViewId
      storedView {
        id
        workspaceId
        key
        name
        ownerId
        ownerType
        default
        showColumnHeaders
        sectionColumnId
        subSectionColumnId
        globalFilter
        columnFilters {
          id
          value
        }
        columnOrder
        columnVisibility
        sorting {
          id
          desc
        }
        expanded
        createdAt
        updatedAt
      }
    }
  }
`);

// ============== MUTATIONS ======================

export const createActiveViewMutationDocument = graphql(/* GraphQL */ `
  mutation CreateActiveView($input: CreateActiveViewInput!) {
    createActiveView(createActiveViewInput: $input) {
      id
      userId
      workspaceId
      key
      showColumnHeaders
      sectionColumnId
      subSectionColumnId
      globalFilter
      columnFilters {
        id
        value
      }
      columnOrder
      columnVisibility
      sorting {
        id
        desc
      }
      expanded
      createdAt
      updatedAt
      storedViewId
      storedView {
        id
        workspaceId
        key
        name
        ownerId
        ownerType
        default
        showColumnHeaders
        sectionColumnId
        subSectionColumnId
        globalFilter
        columnFilters {
          id
          value
        }
        columnOrder
        columnVisibility
        sorting {
          id
          desc
        }
        expanded
        createdAt
        updatedAt
      }
    }
  }
`);

export const updateActiveViewMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateActiveView($input: UpdateActiveViewInput!) {
    updateActiveView(updateActiveViewInput: $input) {
      id
      userId
      workspaceId
      key
      showColumnHeaders
      sectionColumnId
      subSectionColumnId
      globalFilter
      columnFilters {
        id
        value
      }
      columnOrder
      columnVisibility
      sorting {
        id
        desc
      }
      expanded
      createdAt
      updatedAt
      storedViewId
      storedView {
        id
        workspaceId
        key
        name
        ownerId
        ownerType
        default
        showColumnHeaders
        sectionColumnId
        subSectionColumnId
        globalFilter
        columnFilters {
          id
          value
        }
        columnOrder
        columnVisibility
        sorting {
          id
          desc
        }
        expanded
        createdAt
        updatedAt
      }
    }
  }
`);
